import { Component, OnInit } from '@angular/core';
@Component({
    selector: 're-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
    standalone: false
})
export class ContactUsComponent implements OnInit {
  copyrightYear = new Date().getFullYear();
 constructor() { }
 ngOnInit() {
 }
}
